
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-phone"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click)="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-phone"
        tabindex="0"
        type="button"
        class="close close-btn"

        aria-label="Close"
        (click)="dialogData.reset()"
      ></button>
    </div>



    @if (dialogData.isOtherNumber) {
      <div class="edit-nationality-body">
        <div class="modal-form-group">
          <label class="dob-label">Other number:</label>
          <div class="cannot-edit-profile-rectangle">
            <input sanitizeInputForm class="form-input" [(ngModel)]="dialogData.otherNumber"  OnlyNumber="true" maxlength="15"
              minlength="10" placeholder="Enter Number" [formControl]="dialogData.OtherMobileControl">
              @if (dialogData.OtherMobileControl.invalid) {
                <div class="red no-margin">
                  @if (dialogData.OtherMobileControl!.errors!.minlength || dialogData.OtherMobileControl!.errors?.forbiddenName) {
                    <div
                      >
                      Sorry, that is not a valid phone number
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="btn-container">
            <button role="button" tabindex="0" aria-label="save" class="send-button"  (click)="dialogData.saveOtherNumDetails('',dialogData.otherNumber)">Save</button>
          </div>
        </div>
      }
      @if (!dialogData.isOtherNumber) {
        <div class="edit-nationality-body edit-other-phone-modal">
          <div class="other-phone-info">
            Please add a new number or alternatively, if we already have a number for you, please select
            it from the list below
          </div>
          @for (phone of dialogData.filteredOtherNumber; track phone; let i = $index) {
            <div class=" radio-wrapper"
              >
              <input type="radio" name="other-phone" id="other-phone{{i}}" matInput
                value="{{phone.ProfilePhoneId}}" aria-label="07957 465999  (previously Work)"
                [(ngModel)]="dialogData.otherPhoneNumber">
                <label for="other-phone{{i}}">{{phone.PhoneNumber}}
                  <span>({{dialogData.phoneTypes[phone.PhoneType]}})</span></label>
                </div>
              }
              <div class=" radio-wrapper">
                <input type="radio" name="other-phone" id="other-phone-add-new" value="new-number"
                  aria-label="Add a new number" [(ngModel)]="dialogData.otherPhoneNumber">
                  <label for="other-phone-add-new">Add a new number</label>
                </div>
                @if (dialogData.otherPhoneNumber=='new-number') {
                  <div  id="other-new-phone-number"
                    >
                    <input sanitizeInputForm class="form-input" [(ngModel)]="dialogData.otherNumber" OnlyNumber="true" maxlength="15"
                      minlength="10" placeholder="Enter Number" [formControl]="dialogData.OtherMobileControl">
                      @if (dialogData.OtherMobileControl.invalid) {
                        <div class="red ">
                          @if (dialogData.OtherMobileControl!.errors!.required && dialogData.OtherMobileControl.dirty) {
                            <div>
                              Phone number cannot be blank
                            </div>
                          }
                          @if (dialogData.OtherMobileControl!.errors!.minlength || dialogData.OtherMobileControl!.errors?.forbiddenName) {
                            <div role="alert" aria-label="error"
                              >
                              Sorry, that is not a valid phone number
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class=" radio-wrapper">
                    <input type="radio"  name="other-phone" id="other-phone-dont-show" value=""
                      aria-label="Dont display any other number" [(ngModel)]="dialogData.otherPhoneNumber">
                      <label for="other-phone-dont-show">Don't display any other number</label>
                    </div>
                    <div class="btn-container">
                      <button role="button" tabindex="0" aria-label="save" class="send-button" (click)="dialogData.saveOtherNumDetails(dialogData.otherPhoneNumber, dialogData.otherNumber)"
                      >Save</button>
                    </div>
                  </div>
                }
              </div>
            </div>

